import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import { client } from '../http';

export async function scheduleMediumPost({
  unix,
  galleryUsername,
  userID,
  activeTypeshareID,
  attachLink,
  currentSlug,
}) {
  try {
    const { data } = await client.post('/api/scheduling/schedule-medium', {
      timestamp: unix,
      data: {
        sentry: {
          username: galleryUsername,
          id: userID,
          postID: activeTypeshareID,
        },
        userID: userID,
        username: galleryUsername,
        essayID: activeTypeshareID,
      },
    });

    if (!data.success) {
      throw new Error('failed to schedule medium post');
    }
    const postbackID = data.id;
    const essayUserRef = firebase
      .database()
      .ref('users/' + userID + '/typeshares/' + activeTypeshareID);
    await essayUserRef.child('mediumSchedule').update({
      scheduleID: postbackID,
      attachLink,
      link: currentSlug
        ? `https://typeshare.co/${galleryUsername}/posts/${currentSlug}`
        : `https://typeshare.co/${galleryUsername}/posts/${activeTypeshareID}`,
    });
    return { success: true };
  } catch (err) {
    console.error(err);
    return { success: false };
  }
}
